export const imgURL = "/images/";
export const BASE_URL = "https://tsh.trimworldwide.com/admin/";
export const BASE_URL2 = "https://backend.theshippinghack.com/";
